import React from 'react';
import Empty from './empty';
import Normal from './normal'

interface Iprops {
  data?: Array<any>
  isInfo?: boolean
  pClassName?: string
  setMode?: () => void
  loading?: boolean
  location?: string
  has_m2m?: boolean
  isShowList?: boolean
  total?: string
  hasOwen?: boolean
  isShowTotal?: boolean
}

function OwenList(props: Iprops) {
  const {
    data,
    isInfo,
    setMode,
    loading,
    location,
    has_m2m,
    isShowList,
    total,
    isShowTotal,
  } = props
  return (
    <>
      <div className={`${has_m2m || loading ? 'hidden' : ''}`}>
        <Empty
          setMode={setMode}
          isInfo={isInfo}
          location={location}
          total={total}
          hasOwen={has_m2m}
          isShowTotal={isShowTotal}
        />
      </div>
      {
        data && data.length && isShowList ?
          <Normal
            data={data}
            total={total}
            location={location}
            has_m2m={has_m2m}
            hasOwen={has_m2m}
          />
          : ''
      }
    </>
    
  );
}

export default OwenList;
